// extracted by mini-css-extract-plugin
module.exports = {"RitualEmbed":"RitualEmbed_RitualEmbed__Yoc3C","closeButton":"RitualEmbed_closeButton__UKgKN"};